import { render, staticRenderFns } from "./WizardDoneLine.vue?vue&type=template&id=96511806&"
import script from "./WizardDoneLine.vue?vue&type=script&lang=js&"
export * from "./WizardDoneLine.vue?vue&type=script&lang=js&"
import style0 from "./WizardDoneLine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports